module.exports = __webpack_public_path__ + "img/catraca.a190fe75.png";